module.exports = class WYSIWYGTable {

	static get tableSelector() {
		return '.eswp-wysiwyg-table';
	}

	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
		
			const wysiwygTableElements = document.querySelectorAll(this.constructor.tableSelector);
			// console.log('wysiwygTableElements', wysiwygTableElements);

			for (const wysiwygTableElement of wysiwygTableElements) {
				this.tableScrollHandler(wysiwygTableElement);
				wysiwygTableElement.addEventListener('scroll', (event) => {
					this.tableScrollHandler(event.target);
				});
			}

			window.addEventListener('resize', () => {
				for (const wysiwygTableElement of wysiwygTableElements) {
					this.tableScrollHandler(wysiwygTableElement);
				}
			});
			
		});
	}

	tableScrollHandler = (element) => {
		const tableScrollLeft = element.scrollLeft;
		if (tableScrollLeft == 0) {
			element.classList.remove('left-scroll-shadow');
		}
		else {
			element.classList.add('left-scroll-shadow');
		}
		if ((element.scrollWidth - tableScrollLeft) <= (element.offsetWidth + 1)) {
			element.classList.remove('right-scroll-shadow');
		}
		else {
			element.classList.add('right-scroll-shadow');
		}
	}

};